import { PageHeader } from '@/components/brand/PageHeader';
import { Panel } from '@/components/brand/Panel';
import { EmptyState } from '@/components/brand/States';

interface PlaceholderPageProps {
  eyebrow?: string;
  title: string;
  hint: string;
}

/**
 * Generic "coming soon" page for nav entries whose feature is not yet
 * built. Keeps the route navigable and on-brand without faking data.
 */
export function PlaceholderPage({ eyebrow = 'Coming soon', title, hint }: PlaceholderPageProps) {
  return (
    <div className="space-y-5">
      <PageHeader eyebrow={eyebrow} title={title} />
      <Panel title={title}>
        <EmptyState title="Not yet available" hint={hint} />
      </Panel>
    </div>
  );
}
